import styled from 'styled-components';
import { rgba } from 'polished';

import { cFFFFFF } from '#/colors';

const MaxButton = styled.button.attrs({
  children: 'MAX',
  type: 'button',
})`
  background: none;
  border: none;
  color: ${rgba(cFFFFFF, 0.5)};
  font-size: 12px;
  font-weight: 700;
  padding: 8px 8px;

  &:hover {
    color: ${cFFFFFF};
  }
`;

export default MaxButton;
